import { render, staticRenderFns } from "./LoyaltyProgramGuide.vue?vue&type=template&id=4986b974&scoped=true"
import script from "./LoyaltyProgramGuide.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgramGuide.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyProgramGuide.vue?vue&type=style&index=0&id=4986b974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4986b974",
  null
  
)

export default component.exports